<template>
  <section class="empty-human-profile">
    <p
      class="empty-human-profile__title"
    >
      <span>
        {{ $t('emptyHumanProfile.youDontHaveFriends') }}
      {{ $t('emptyHumanProfile.addNewFriend') }}
      <br>
      {{ $t('emptyHumanProfile.toStartEvents') }}
      </span>
    </p>
    <button-app
      class="empty-human-profile__button"
      color-scheme="blue"
      @clicked="openAddFriend"
    >
      {{ $t('emptyHumanProfile.newFriend') }}
    </button-app>
  </section>
</template>

<script>
import ButtonApp from '../Button/ButtonApp';

export default {
  name: 'EmptyHumanProfile',
  components: { ButtonApp },
  methods: {
    openAddFriend() {
      this.$bvModal.show('add-friend');
    },
  },
};
</script>

<style scoped>
  .empty-human-profile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #FFFFFF;
    color: var(--text-main-color);
  }
  .empty-human-profile__button {
    width: 228px;
    height: 38px;
    margin: 0;
    font-size: 13px;
    line-height: 22px;
  }
</style>
